import React from 'react'

import { Stepper } from '../../../components/quebec-lease/stepper'

const CreateEmptyLease: React.FC = () => {
  return <Stepper skipPrepare />
}

export { CreateEmptyLease }
